var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsReceptors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H8.65039V7.34961H14V8.65039H11.6504V10H13V14H9V10H10.3496V8.65039H5.65039V10H7V14H3V10H4.34961V8.65039H2V7.34961H7.34961V6H5V2H11V6ZM4.2998 12.7002H5.7002V11.2998H4.2998V12.7002ZM10.2998 12.7002H11.7002V11.2998H10.2998V12.7002ZM6.2998 4.7002H9.7002V3.2998H6.2998V4.7002Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsReceptors);
export default __webpack_public_path__ + "static/media/icons-receptors.c2acd7b2.svg";
export { ForwardRef as ReactComponent };